import { Paragraph, Separator, usePageWidth, MarginBox } from '@fs/zion-ui'
import React from 'react'
import NoItemsMessageSkeleton from './NoItemsMessageSkeleton'

type Props = {
  /**
   * The section heading, already translated and without its count. A plain string rather than a
   * CategoryType so a section outside that union — third party hints — loads like the rest.
   */
  title: string
}

// Mirrors a single loading section: the title followed by a "no items" skeleton. On desktop the
// real header is an `ExpanderHeader`; on smaller screens it is a plain `Paragraph`. This replicates
// both without the interactive Expander, which has nothing to collapse while the section is still
// loading and is a trap for anyone who clicks it.
export default function CategorySkeleton({ title }: Props): JSX.Element {
  const isDesktop = usePageWidth()({ md: true })

  if (isDesktop) {
    return (
      <>
        <MarginBox marginY="xs">
          <h2>
            <MarginBox marginY="nano">{title}</MarginBox>
          </h2>
        </MarginBox>
        <NoItemsMessageSkeleton />
      </>
    )
  }

  return (
    <>
      <Paragraph size="sm">{title}</Paragraph>
      <Separator size="nano" />
      <NoItemsMessageSkeleton />
    </>
  )
}
